<template>
    <div class="rounded mx-auto my-2 text-sm bg-primary-lightest text-primary border-primary border p-3" v-if="offer">
        <p>🎉 Hurray! You are eligible for an offer today if you upgrade – <strong>{{ offer.description }}</strong>.</p>
    </div>
</template>

<script setup>
    export default {
        data() {
            return {
                offer: null,
            }
        },

        mounted() {
            axios.get('/api/me')
                .then(response => {
                    this.offer = response.data.data.best_available_offer;
                })
                .catch(console.error);
        },
    }
</script>
